import { RCCServicesApi } from "react-common-components";
import { IMessage } from "react-common-components/dist/components/Toast/interface";
import { standardErrorMessages } from "src/utils/errors";

const getMicrosoftDomainOfEmail = async (email: string, translate: (text: string, objKeys?: object | undefined) => string, addToast: (message: Omit<IMessage, "id">) => void) => {
	let configs;
	try{
		const response = await RCCServicesApi.getRequest({
			method: "DomainsPublic/GetDomainConfiguration",
			urlParameters: {
				email
			}
		});
	
		const domainResponse = response.data;
	
		if(domainResponse === null || domainResponse.type === null || domainResponse.type !== 1 || domainResponse.configs === null){
			addToast({
				color: "red",
				description: translate("Domínio não cadastrado"),
				title: translate("Erro")
			});
			return configs;
		}
	
		configs = JSON.parse(domainResponse.configs);
	}catch(err){
		standardErrorMessages(err, "Domínio não cadastrado", addToast);
	}
	return configs;
};

export default getMicrosoftDomainOfEmail;
